/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { CheckBox, Label, HasPermission, Icon, Row } from "@fitinsur/components";

import Mask from "@fitinsur/utils/src/mask";

export default function contactColumns({
  setDialogConfirmation,
  setEditContact,
  setAddContact,
  setSelectedContact,
  setMainContact,
  setModalConfirmationDetails,
  questionnaire,
  personHandler,
  getDescription,
  setFieldValue,
  setQuestionnaire,
  user,
}) {
  const mask = new Mask();
  return [
    {
      title: getDescription("DOMAINS", 1076),
      value: "postmailAddress",
      key: "postmailAddress",
			minWidth: 5,
			maxWidth: 5,
      // ellipsis: true,
			component: (listItem) => <CheckBox
				checked={listItem.address?.postmailAddress}
				// onClick={() => setMainContact(listItem.idContact)}
			/>
		},
    {
      title: getDescription("DOMAINS", 820),
      value: "mainContact",
      key: "mainContact",
			minWidth: 3,
			maxWidth: 3,
			component: (listItem) => <CheckBox
				checked={listItem.mainContact}
				onClick={() => setMainContact(listItem.idContact)}
			/>
		},
    {
      title: getDescription("DOMAINS", 821),
      value: "contactType",
      key: "contactType",
      minWidth: 7,
      maxWidth: 7,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        let contactType;

        const contactIdDomainMapping = {
          30: 841, //Address
          31: 842, //Phone
          32: 843, //E-mail
          33: 844, //Website
          282: 845, //Focal Point
        }

        if (listItem?.idDomain)
          contactType = getDescription("DOMAINS", contactIdDomainMapping[listItem.idDomain]);

        return (
          <Label wordWrap fontSize={14}>
            {contactType}
          </Label>
        )
      }
    },
    {
      title: getDescription("DOMAINS", 822),
      value: "description",
      key: "description",
      minWidth: 12,
      maxWidth: 12,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        if (listItem.idDomain === 30) {
          return (
            <Label wordWrap fontSize={14}>
              <>
                {listItem?.address?.streetName}, {listItem?.address?.doorNumber}, {listItem?.address?.complementary && (<>{listItem?.address?.complementary},</>) }<br />
                {listItem?.address?.district}, {listItem?.address?.city} - {listItem?.address?.state} <br />
                {listItem?.address?.zipCode.slice(0, 5) + '-' + listItem?.address?.zipCode.slice(5)}, {listItem?.address?.country}
              </>
            </Label>
          )
        } else {
          return (
            <Label wordWrap fontSize={14}>
              {listItem.idDomain === 31 ? Mask.tel(listItem.contactDescription) : listItem.contactDescription}
              {console.log(listItem)}
            </Label>
          )
        }
      }
    },
    {
      title: getDescription("DOMAINS", 827),
      key: "action",
      minWidth: 10,
      maxWidth: 10,
      paddingRight: 5,
      component: (listItem) => {
        const { idDomain, mainContact, contactDescription, idPersonRelationship } = listItem
        const isUserName = contactDescription === user?.userName;
        const hasRelationship = Boolean(idPersonRelationship);
        const isDisabled = isUserName || mainContact || (idDomain === 30 && !hasRelationship);

        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
            <Row className="align-items-center justify-content-start" style={{ width: 65 }}>
              <HasPermission permission={!(idDomain === 30 && !hasRelationship)}>
                <Icon
                  name="edit"
                  title={getDescription("DOMAINS", 812)}
                  disabled={false}
                  onClick={() => {
                    setEditContact(true);
                    setAddContact(false);
                    setSelectedContact(listItem);
                    personHandler.events.handleEditContact({
                      questionnaire,
                      setQuestionnaire,
                      setFieldValue,
                      listItem,
                      hasRelationship
                    });
                  }}
                />
                <Icon
                  name="trash"
                  title={getDescription("DOMAINS", 818)}
                  disabled={isDisabled}
                  onClick={() => {
                    setSelectedContact(listItem);
                    setDialogConfirmation({ visible: true })
                    setModalConfirmationDetails({
                      text: getDescription("DOMAINS", 814),
                      textButtonConfirm: getDescription("DOMAINS", 815),
                      textButtonCancel: getDescription("DOMAINS", 816),
                      type: "contact"
                    })
                  }}
                />
              </HasPermission>
            </Row>
          </div>
        )
      }
    }
  ];
}
